import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Plugin } from '../../../core/backup/backup.model';

@Component({
  selector: 'app-plugins-information-dialog',
  templateUrl: './plugins.component.html',
  styleUrls: [`./plugins.styles.scss`],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PluginInformationDialogComponent implements OnInit {
  prevBackupPlugins: Plugin[];
  plugins: Plugin[];
  pluginChip: string[];
  backupTimestamp: string;
  displayedColumns = ['plugins', 'changes'];
  dataSource = new MatTableDataSource();
  // TODO: translate these chips
  private readonly installed: string = 'Installed';
  private readonly updated: string = 'Updated';
  private readonly activated: string = 'Activated';
  private readonly deactivated: string = 'Deactivated';

  constructor(
    public dialogRef: MatDialogRef<PluginInformationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.plugins = data.plugins;
    this.backupTimestamp = data.timestamp;
    this.prevBackupPlugins = data.prevBackupPlugins;
  }

  ngOnInit(): void {
    this.dataSource.data = this.plugins;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  checkPluginDiff(currentPlugin: Plugin): boolean {
    this.pluginChip = [];
    if (this.prevBackupPlugins.length === 0) return false;

    const prevPlugin = this.prevBackupPlugins.find((p) => currentPlugin.name === p.name);

    if (prevPlugin === undefined) {
      this.pluginChip.push(this.installed);
      return true; // return here since there is no need to compare version and status for new plugins
    }

    if (prevPlugin.version !== currentPlugin.version) {
      this.pluginChip.push(this.updated);
    }

    if (prevPlugin.status !== currentPlugin.status) {
      if (currentPlugin.status === 'inactive') {
        this.pluginChip.push(this.deactivated);
      } else {
        this.pluginChip.push(this.activated);
      }
    }
    return this.pluginChip.length > 0;
  }
}
